import basicInfo from '../env.json';

export const ENV: 'dev' | 'prod' | 'inmemory' = basicInfo.env as any;

export const BACKEND_CONFIG = basicInfo.backendConfig;
